jQuery(document).ready(function () {
  /*
        Background slideshow
    */

  $('.coming-soon').backstretch(['https://anfa.ca/cdn/shop/t/8/assets/4.jpg?v=23938985185103622061765398903'], {
    duration: 3000,
    fade: 750,
  });

  /*
	    Countdown initializer
	*/
  const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
  const currentDate = new Date();
  const targetDate = new Date('August 6, 2025');
  const distance = targetDate.getTime() - currentDate.getTime();
  const daysUntil = Math.floor(distance / oneDay);

  var countTo = daysUntil * oneDay + currentDate.valueOf();
  $('.timer').countdown(countTo, function (event) {
    $(this).find('.days').text(event.offset.totalDays);
    $(this).find('.hours').text(event.offset.hours);
    $(this).find('.minutes').text(event.offset.minutes);
    $(this).find('.seconds').text(event.offset.seconds);
  });

  /*
        Tooltips
    */
  $('.social a').tooltip();
});
